
/**
 * @Title 常量
 * @author Alinc
 * @time 2019-10-9 11:27:04
 */
import { lang } from '@/utils/filters'
const { VUE_APP_API_URL } = process.env
export const I18N_URL = process.env.VUE_APP_in18_URL
// 环境变量
export const ENV = process.env.NODE_ENV

// 是否为正式环境
export const IS_PROD = ENV === 'production'

// 基本请求路径
export const BASE_URL = IS_PROD ? VUE_APP_API_URL : '/api'

// excel上传路径
export const EXCEL_URL = VUE_APP_API_URL + '/vip/order/excelImport'

// excel 上传地址路径
export const EXCEL_URL_3 = VUE_APP_API_URL + '/vip/address/importData'

// excel上传路径,省、市、区、详细地址未拆分，需要系统智能拆分
export const EXCEL_URL_2 = VUE_APP_API_URL + '/vip/order/excelImportMatchAddress'

// 新批量打入模板 20201209新增
export const EXCEL_IMPORT = VUE_APP_API_URL + '/vip/excel/excelImport'

// 图上传路径-暂无
export const IMG_URL = VUE_APP_API_URL + ''

// 请求成功
export const RESPONSE_SUCCESS = 1

// token过期
export const RESPONSE_EXPIRED = '000002'

// 请求中断标识
export const INTERRUPT = 'INTERRUPT'
// 静态字典
export const DIC = {
  payTypes: [{ code: 'PP_PM', name: '寄付月结', id: 319, type: 'ZD106' }, { code: 'PP_CASH', name: '寄付现结', id: 320, type: 'ZD106' }, { code: 'CC_CASH', name: '到付现结', id: 321, type: 'ZD106' }],
  specTypes: [{ name: '物品类型2', code: 'B0002' }, { name: '物品A', code: 'article21' }, { name: '包装箱', code: '12457' }],
  insured: [{ code: 0, label: '否', name: '否' }, { code: 1, label: '是', name: '是' }],
  signReceipt: [{ code: 0, label: '否', name: '否' }, { code: 1, label: '是', name: '是' }],
}
// 后端语种与element国际化的对应map
export const LANG_ELEMENT_MAP = {
  'CN': 'zh-cn', // 中文
  'EN': 'en', // 英语
  'TH': 'th', // 泰语
  'KH': 'kh', // 柬埔寨(暂无)
  'MY': 'my', // 马来语(暂无)
  'ID': 'id', // 印尼语
  'VN': 'vi', // 越南语
  'AR': 'ar', // 阿拉伯语

}
// 静态菜单
export const MENU = [
  {
    'routeName': 'orders',
    'id': 537,
    'menuIcon': 'iconwoyaojijian',
    'name': '我要寄件',
    'parentId': 527,
    'moduleType': 2,
    'isShow': 1,
    'children': [
      {
        'isShow': 1,
        'routeName': 'singleOrder',
        'id': 813,
        'menuIcon': '',
        'name': '单票下单',
        'parentId': 538,
        'moduleType': 3,
      },
      {
        'isShow': 1,
        'routeName': 'batchOrder',
        'children': null,
        'id': 809,
        'menuIcon': '',
        'name': '批量下单',
        'parentId': 539,
        'moduleType': 3,
      },
    ],
  },
  {
    'routeName': 'order',
    'id': 540,
    'menuIcon': 'iconwodedingdan',
    'name': '我的订单',
    'parentId': 527,
    'moduleType': 3,
    'isShow': 1,
  },
  // {
  //   'routeName': 'orderList',
  //   'id': 540,
  //   'menuIcon': 'iconwodedingdan',
  //   'name': '我的订单',
  //   'parentId': 527,
  //   'moduleType': 2,
  //   'isShow': 1,
  //   'children': [
  //     {
  //       'isShow': 1,
  //       'routeName': 'order',
  //       'id': 813,
  //       'menuIcon': '',
  //       'name': '网页下单',
  //       'parentId': 540,
  //       'moduleType': 3,
  //     },
  //     //   {
  //     //     'isShow': 1,
  //     //     'routeName': 'externalOrders',
  //     //     'children': null,
  //     //     'id': 811,
  //     //     'menuIcon': '',
  //     //     'name': '三方下单',
  //     //     'parentId': 540,
  //     //     'moduleType': 3,
  //     //   },
  //   ],
  // },
  {
    'routeName': 'waybill',
    'id': 541,
    'menuIcon': 'iconwodeyundan',
    'name': '我的运单',
    'parentId': 527,
    'moduleType': 3,
    'isShow': 1,
  },
  {
    'routeName': 'expressTracking',
    'id': 813,
    'menuIcon': 'iconfuwuguanli',
    'name': '快件跟踪',
    'parentId': 527,
    'moduleType': 3,
    'isShow': 1,
  },
  // {
  //   'routeName': 'workBench',
  //   'id': 542,
  //   'menuIcon': 'iconfuwuguanli',
  //   'name': '服务管理',
  //   'parentId': 527,
  //   'moduleType': 2,
  //   'isShow': 1,
  //   'children': [
  //     {
  //       'isShow': 1,
  //       'routeName': 'expressTracking',
  //       'children': null,
  //       'id': 813,
  //       'menuIcon': '',
  //       'name': '快件跟踪',
  //       'parentId': 542,
  //       'moduleType': 3,
  //     },
  //     //  {
  //     //    'isShow': 1,
  //     //    'routeName': 'freightInquiry',
  //     //    'children': null,
  //     //    'id': 809,
  //     //    'menuIcon': '',
  //     //    'name': '运费查询',
  //     //    'parentId': 542,
  //     //    'moduleType': 3,
  //     //  },
  //   ],
  // },
  {
    'routeName': 'addressManage',
    'id': 545,
    'menuIcon': 'icondizhiguanli',
    'name': '地址管理',
    'parentId': 527,
    'moduleType': 2,
    'isShow': 1,
    'children': [
      {
        'isShow': 1,
        'routeName': 'mailingAddress',
        'children': null,
        'id': 823,
        'menuIcon': '',
        'name': '寄件地址',
        'parentId': 545,
        'moduleType': 3,
      },
      {
        'isShow': 1,
        'routeName': 'receivingAddress',
        'children': null,
        'id': 829,
        'menuIcon': '',
        'name': '收件地址',
        'parentId': 545,
        'moduleType': 3,
      },
    ],
  },
  {
    'routeName': 'userManage',
    'id': 57,
    'menuIcon': 'iconyonghuguanli',
    'name': '用户管理',
    'parentId': 546,
    'moduleType': 3,
    'isShow': 1,
  },
]

// 运单导出字段
export const cityOptions = [
  {
    key: 'waybillNo',
    name: '运单编号',
    required: true,
    disabled: true,
  },
  {
    key: 'subNo',
    name: '子单号',
    required: true,
    disabled: true,
  },
  {
    key: 'waybillStatusName',
    name: '状态',
    required: true,
    disabled: true,
  },
  {
    key: 'orderSourceName',
    name: '下单渠道',
    required: true,
    disabled: true,
  },
  {
    key: 'customerOrderId',
    name: '客户订单号',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverName',
    name: '收件人',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverProvinceName',
    name: '收件省份',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverCityName',
    name: '收件城市',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverAreaName',
    name: '收件区域',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverDetailedAddress',
    name: '收件地址',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverMobilePhone',
    name: '收件电话',
    required: true,
    disabled: true,
  },

  {
    key: 'senderName',
    name: '寄件人',
  },
  {
    key: 'senderProvinceName',
    name: '寄件省份',
  },
  {
    key: 'senderCityName',
    name: '寄件城市',
  },
  {
    key: 'senderAreaName',
    name: '寄件区域',
  },
  {
    key: 'senderDetailedAddress',
    name: '寄件地址',
  },
  {
    key: 'senderMobilePhone',
    name: '寄件电话',
  },
  {
    key: 'goodsTypeName',
    name: '物品类型',
  },
  {
    key: 'goodsName',
    name: '物品名称',
  },
  {
    key: 'packageTotalWeight',
    name: '物品重量',
  },
  {
    key: 'packageNumber',
    name: '总件数',
  },
  {
    key: 'packageTotalVolume',
    name: '总体积(m³)',
  },
  {
    key: 'packageVolume',
    name: '总体积重(kg)',
  },
  {
    key: 'packageChargeWeight',
    name: '计费重量(kg)',
  },
  {
    key: 'insuredAmount',
    name: '物品价值',
  },
  {
    key: 'insuredFee',
    name: '保价费',
  },
  {
    key: 'receiptFee',
    name: '回单费',
  },
  {
    key: 'upstairsFee',
    name: '上楼费',
  },
  {
    key: 'boxPrice',
    name: '箱材价格',
  },
  {
    key: 'settlementName',
    name: '支付方式',
  },
  // {
  //   key: 'codMoney',
  //   name: 'COD',
  // },
  // {
  //   key: 'codFee',
  //   name: 'COD手续费',
  // },
  {
    key: 'freight',
    name: '参考运费',
  },
  {
    key: 'totalFreight',
    name: '总运费',
  },
  // {
  //   key: 'orderSourceName',
  //   name: '下单渠道',
  // },
  {
    key: 'remarks',
    name: lang('备注'),
  },
  {
    key: 'receiptNo',
    name: lang('回单号'),
  },
]

// 订单导出字段
export const orderOptions = [
  {
    key: 'id',
    name: '订单编号',
    required: true,
    disabled: true,
  },
  {
    key: 'waybillId',
    name: '运单编号',
    required: true,
    disabled: true,
  },
  {
    key: 'subWaybillIds',
    name: '子单号',
    required: true,
    disabled: true,
  },
  {
    key: 'orderStatusName',
    name: '状态',
    required: true,
    disabled: true,
  },
  {
    key: 'customerOrderId',
    name: '客户订单号',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverName',
    name: '收件人',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverMobilePhone',
    name: '收件电话',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverProvinceName',
    name: '收件省份',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverCityName',
    name: '收件城市',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverAreaName',
    name: '收件区域',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverDetailedAddress',
    name: '收件地址',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverCompany',
    name: '收件人公司',
  },
  {
    key: 'senderName',
    name: '寄件人',
  },
  {
    key: 'senderMobilePhone',
    name: '寄件电话',
  },
  {
    key: 'senderProvinceName',
    name: '寄件省份',
  },
  {
    key: 'senderCityName',
    name: '寄件城市',
  },
  {
    key: 'senderAreaName',
    name: '寄件区域',
  },
  {
    key: 'senderDetailedAddress',
    name: '寄件地址',
  },
  {
    key: 'goodsTypeName',
    name: '物品类型',
  },
  {
    key: 'goodsName',
    name: '物品名称',
  },
  {
    key: 'packageTotalWeight',
    name: '物品重量',
  },
  {
    key: 'packageNumber',
    name: '总件数',
  },
  {
    key: 'totalPackageVolume',
    name: '总体积(m³)',
  },
  {
    key: 'packateVolume',
    name: '总体积重(kg)',
  },
  {
    key: 'packageChargeWeight',
    name: '计费重量(kg)',
  },
  {
    key: 'printsNumber',
    name: '打印次数',
  },
  {
    key: 'declaredValue',
    name: '物品价值',
  },
  {
    key: 'insuredValue',
    name: '保价费',
  },
  {
    key: 'receiptFreight',
    name: '回单费',
  },
  {
    key: 'upStairsValue',
    name: '上楼费',
  },
  {
    key: 'paymentModeName',
    name: '支付方式',
  },
  {
    key: 'standardValue',
    name: '参考运费',
  },
  {
    key: 'totalFreight',
    name: '总运费',
  },
  {
    key: 'orderSourceName',
    name: '订单来源',
  },
  {
    key: 'receiptWaybillNo',
    name: '回单号',
  },
  {
    key: 'remarks',
    name: '备注',
  },
  //   {
  //     key: 'orderAccount',
  //     name: '下单账号',
  //   },
]

// 第三方订单导出字段
export const customerOrderOptions = [
  {
    key: 'id',
    name: lang('订单编号'),
    required: true,
    disabled: true,
  },
  {
    key: 'waybillId',
    name: lang('运单编号'),
    required: true,
    disabled: true,
  },
  {
    key: 'orderStatusName',
    name: lang('状态'),
    required: true,
    disabled: true,
  },
  {
    key: 'orderSourceName',
    name: lang('订单来源'),
    required: true,
    disabled: true,
  },
  {
    key: 'printsNumber',
    name: lang('打印次数'),
    required: true,
    disabled: true,
  },
  {
    key: 'customerOrderId',
    name: lang('客户订单号'),
    required: true,
    disabled: true,
  },
  {
    key: 'customerWaybillNo',
    name: lang('第三方运单号'),
    required: true,
    disabled: true,
  },
  {
    key: 'receiverName',
    name: lang('收件人'),
    required: true,
    disabled: true,
  },
  {
    key: 'receiverMobilePhone',
    name: lang('收件电话'),
    required: true,
    disabled: true,
  },
  {
    key: 'receiverProvinceName',
    name: lang('收件省份'),
    required: true,
    disabled: true,
  },
  {
    key: 'receiverCityName',
    name: lang('收件城市'),
    required: true,
    disabled: true,
  },
  {
    key: 'receiverAreaName',
    name: lang('收件区域'),
    required: true,
    disabled: true,
  },
  {
    key: 'receiverDetailedAddress',
    name: lang('收件地址'),
    required: true,
    disabled: true,
  },
  {
    key: 'receiverCompany',
    name: lang('收件人公司'),
  },
  {
    key: 'senderName',
    name: lang('寄件人'),
  },
  {
    key: 'senderMobilePhone',
    name: lang('寄件电话'),
  },
  {
    key: 'senderProvinceName',
    name: lang('寄件省份'),
  },
  {
    key: 'senderCityName',
    name: lang('寄件城市'),
  },
  {
    key: 'senderAreaName',
    name: lang('寄件区域'),
  },
  {
    key: 'senderDetailedAddress',
    name: lang('寄件地址'),
  },
  {
    key: 'goodsTypeName',
    name: lang('物品类型'),
  },
  {
    key: 'goodsName',
    name: lang('物品名称'),
  },
  {
    key: 'packageTotalWeight',
    name: lang('物品重量'),
  },
  {
    key: 'declaredValue',
    name: lang('物品价值'),
  },
  {
    key: 'insuredValue',
    name: lang('保价费'),
  },
  {
    key: 'paymentModeName',
    name: lang('支付方式'),
  },
  {
    key: 'standardValue',
    name: lang('参考运费'),
  },
  {
    key: 'remarks',
    name: lang('备注'),
  },
  //   {
  //     key: 'orderAccount',
  //     name: '下单账号',
  //   },
]
